/**
 * @generated SignedSource<<36d1f66525d5115fad18b641b62877c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SageSyncAnalysisTable_Query$variables = {
  companyId?: number | null;
  analysisId?: number | null;
};
export type SageSyncAnalysisTable_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SageSyncAnalysisTable_viewer">;
  } | null;
};
export type SageSyncAnalysisTable_Query = {
  variables: SageSyncAnalysisTable_Query$variables;
  response: SageSyncAnalysisTable_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "analysisId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "companyId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "sage_sync_analysis_table"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"sage_sync_analysis_table\")"
},
v4 = [
  {
    "kind": "Variable",
    "name": "analysisId",
    "variableName": "analysisId"
  },
  {
    "kind": "Variable",
    "name": "companyId",
    "variableName": "companyId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relevancy",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SageSyncAnalysisTable_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": (v4/*: any*/),
            "kind": "FragmentSpread",
            "name": "SageSyncAnalysisTable_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SageSyncAnalysisTable_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlDataType",
            "kind": "LinkedField",
            "name": "missionControlData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "MissionControlSageSyncAnalysisType",
                "kind": "LinkedField",
                "name": "companySyncAnalysis",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "syncDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MissionControlSageSyncAnalysisEntryType",
                    "kind": "LinkedField",
                    "name": "entries",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "companyAnalysisId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "forecastCompanyId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sageEntityRecordNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "forecastEntityId",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MissionControlSageSyncAnalysisIssueHandlerType",
                    "kind": "LinkedField",
                    "name": "supportedIssueHandlers",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b9cd3dec065e8837d2bed03325bbf759",
    "id": null,
    "metadata": {},
    "name": "SageSyncAnalysisTable_Query",
    "operationKind": "query",
    "text": "query SageSyncAnalysisTable_Query(\n  $companyId: Int\n  $analysisId: Int\n) {\n  viewer {\n    actualPersonId\n    component(name: \"sage_sync_analysis_table\")\n    ...SageSyncAnalysisTable_viewer_1OPT0D\n    id\n  }\n}\n\nfragment SageSyncAnalysisTable_viewer_1OPT0D on Viewer {\n  id\n  missionControlData {\n    companySyncAnalysis(companyId: $companyId, analysisId: $analysisId) {\n      id\n      companyId\n      syncDate\n      entries {\n        id\n        companyAnalysisId\n        forecastCompanyId\n        sageEntityRecordNumber\n        forecastEntityId\n        entityType\n        relevancy\n        description\n      }\n      supportedIssueHandlers {\n        entityType\n        relevancy\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a581027104645ce1a4fb3b793e9f0a3";

export default node;
